import { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useScrollAnimation from "../hooks/useScrollAnimation";
import BookingCard from "../components/BookingCard/booking-card";
import FeatureServices from "../components/FeaturedServices/feature-services";
import HeroSection from "../components/HeroSection/HeroSection";
import Title from "../components/Title/title";
import { collection1, collection2, collection3 } from "../helper/utils";
import { fetchTestimonials } from "../services/api";
import "./pages.css";

const HomePage = () => {
  const navigate = useNavigate();
  const collectionRef1 = useRef(null);
  const collectionRef2 = useRef(null);
  const collectionRef3 = useRef(null);

  const [testimonials, setTestimonials] = useState([
    {
      id: 1,
      text: "Confident in every suit. Unmatched craftsmanship.",
      author: "Jayanshu Prajapati.",
    },
    {
      id: 2,
      text: "Elegant finish, and a truly premium experience.",
      author: "Vinit Rana.",
    },
    {
      id: 3,
      text: "Every detail felt tailored to my style and fit perfectly.",
      author: "Dhruv Thakar.",
    },
  ]);
  const [activeTestimonialIndex, setActiveTestimonialIndex] = useState(0);

  useEffect(() => {
    const loadTestimonials = async () => {
      try {
        const data = await fetchTestimonials();
        if (data && data.length > 0) {
          setTestimonials(data);
        }
      } catch (error) {
        console.warn("Using default testimonials due to API error:", error);
      }
    };
    loadTestimonials();
  }, []);

  useEffect(() => {
    if (testimonials.length <= 1) {
      return undefined;
    }

    const intervalId = window.setInterval(() => {
      setActiveTestimonialIndex(
        (prevIndex) => (prevIndex + 1) % testimonials.length,
      );
    }, 3500);

    return () => window.clearInterval(intervalId);
  }, [testimonials]);

  const activeTestimonial =
    testimonials[activeTestimonialIndex] || testimonials[0];

  useScrollAnimation([collectionRef1, collectionRef2, collectionRef3]);

  return (
    <div className="home-page">
      <HeroSection />
      <BookingCard />

      <div className="home-two">
        <div className="hero-text-container slide-fade-up">
          <div className="line-separator"></div>
          <p className="hero-text-h">
            With over 25 years of experience, we offer expertly tailored Men's
            Suits, Sherwani, Jodhpuri, Indo-western, Shirts, Pants, Ready-made
            Kurtas, and accessories. Our commitment to quality and personalized
            service ensures you receive a suit that looks and fits like a dream.
          </p>
          <div className="line-separator"></div>
        </div>

        <div className="max-width-class padding-class">
          <Title title="Featured Services" isRight={true} />
          <FeatureServices />
        </div>

        <div className="signature-collection-main">
          <Title title="Signature Collection" />

          <div className="signature-collection">
            <div
              ref={collectionRef1}
              className="signature-main-div animate-on-scroll"
            >
              <img
                src={collection1}
                alt="Collection One"
                className="signature-img"
              />

              <div className="signature-text-container">
                <p className="signature-title">Indo Western Collection</p>
                <p className="signature-text">
                  These unique pieces combine the richness of Indian textiles
                  with contemporary Western silhouettes, offering a perfect
                  balance of style and comfort.
                </p>
              </div>
            </div>
            <div
              ref={collectionRef2}
              className="signature-main-div animate-on-scroll"
            >
              <img
                src={collection2}
                alt="Collection One"
                className="signature-img"
              />

              <div className="signature-text-container">
                <p className="signature-title">Sherwani Collection</p>
                <p className="signature-text">
                  Each Sherwani is meticulously crafted from the finest fabrics,
                  featuring intricate embroidery and timeless designs.
                </p>
              </div>
            </div>
            <div
              ref={collectionRef3}
              className="signature-main-div animate-on-scroll"
            >
              <img
                src={collection3}
                alt="Collection One"
                className="signature-img"
              />

              <div className="signature-text-container">
                <p className="signature-title">Jodhpuri Collection</p>
                <p className="signature-text">
                  Step into royalty with our Jodhpuri Collection.Crafted with
                  premium materials and adorned with subtle yet striking
                  details.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="max-width-class testimonials-marquee">
          <div className="testimonials-card">
            <div className="testimonials-text-viewport">
              <div
                className="testimonials-text-container testimonials-text-swipe"
                key={activeTestimonial.id}
              >
                <p className="testimonials-text">"{activeTestimonial.text}"</p>
                <p className="testimonials-text" style={{ textAlign: "right" }}>
                  - {activeTestimonial.author}
                </p>
              </div>
            </div>
            <div className="vertical-line"></div>
            <p className="testimonials-huge-text">Testimonials</p>
            <div className="verticals-div">
              <div className="vertical-line-2"></div>
              <p className="testimonials-huge-text2">Testimonials</p>
            </div>
          </div>
        </div>

        <div className="max-width-class">
          <div className="get-in-touch-card">
            <p className="get-in-touch-text">Get in touch</p>
            <div className="get-in-touch-text-container">
              <div className="line-separator-contact"></div>

              <div className="lower-text-container">
                <p className="get-in-touch-text-two">
                  Precision Tailoring Begins with a Conversation
                </p>
                <div className="get-in-touch-btn-wrapper">
                  <button
                    className="hero-btn"
                    onClick={() => {
                      navigate("/contact-us");
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                  >
                    Contact Us
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
